// axiosClient.js



/*
  ENV expectations:
  - REACT_APP_SERVER_PUBLIC_KEY  -> server public key (PEM). Use \n in .env or base64 as previously discussed.
  - REACT_APP_CLIENT_PRIVATE_KEY -> client private key (PEM) used to decrypt server response (PEM)
*/

export const SERVER_PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEArtuavHuyopu+Lhz57aPED
6iCz3hlgopicAVU4UsPAgzF5uw8hy97x2jjtn1I+jyYxoQy8HAB/GMzY7dlnoEY
wVZEM0Wgp+NIiZ2i7BQCsdSZzkgCrCHt3X9YZRwNE4XPqKXJT09ES4hL1FyOBvd4
1lbQhrDvE4nskAJ3k4lprK1VH1rhqveC9B/Nn70eqX0Dt0GM0LMB9fnU/9gSaMBc
zebAh7rLRJ64Z8XZNSrNqa9/aHxZAVpCfT773DfviB44W7JMopR9q7vSpwWnBxEe
9/Viipwip+ZWXu9Q+fOI/o5bYU1AoyZfBfA6BUAgD179CXk88ikI4OIGsQyRbeDM
PwIDAQAB
-----END PUBLIC KEY-----`;

export const SERVER_PRIVATE_KEY = `-----BEGIN PRIVATE KEY-----
MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQCtBv9N+ZiVS5Ij
YBpa7cOX6a8dJtSpiqAiPWnH887wiMJhFaEC+OXYSyaneIsurKJb3cX1w2gzSTFt
yPNjVo2RY9mRU7UjwS0j0ShWfjxEITNWBFzM9e7tghlC2eJ7XCrc/PyypzKcLg11
k9I+gZsaW5maMO9vW7bheCU6BHsKztX93NyzR65M1P4878JIHsTfdEVrrpb+kFT9
LojU5CgHMu81aG+R2csEvRm+sCzsxjAD/5oGYFXx6ZhvPg2COBZyQh654yEDtkCZ
JuEddfDSDe6XukNPmkVmijkx2Q7yx4MEqNY7evvWqAbJrF7iB2ERNT5CZb1kX4Ip
OWJbC5UhAgMBAAECggEAAiSenXYNqXclS126yB8+6cp64QyyW+PJqId6xMipIX6w
IsjWpx58XJUq2Ing0biaO1dW/cWxh9fxF1tLz0kq3f78mpUM1ZX2pODsT0OnSJQq
+lIMFVgVTu18ugnQQAUuOHFWSjFRqkvUS/1et0N5+Jp11pNZurKA9suoumCo+OfZ
IpxKHIArft8J5ldPTxsZj1e14qgqsVZqaic8JAtJeU99cttw0mYFEwdAOdm4H/ca
/f7IaZHm5X1YdqIC0J1qCME9JuuuZJIaTK35nGL2ryZC06Y8trodoGuI6W8ow5+G
hm92dts8Yjcl4y32DxYZ1dpCM2PyFllrEv1dctWj+QKBgQDWnY4n/1c6Yjvi5MYR
6laYi5sUCf556FKxvAb03WKLxxjC6nmJ/sVfSTtsRvZquxIsYKk3MdK39GLEAdrn
KfhCH8twAEwB7sKMR56Fz8p/Ze9WZWa6c3PH/RmiDE0Zr8R25N8WiHUQZk5ItJgB
J9h49V/brERNhw2COe2vq5rqBwKBgQDOZHQk0dteUoFvbn0mdVoHsZyc2yN6aoDv
8Cq6q7mKOGjHcPL2ecOUOKfZRhfACnpnIb3K+atL0o70VS21gsx3GJKOPEGN1it6
T9L3KxEb34WBspOT6N1Mw6IXPx2DBuhrHIxH7wpN68R9R9vWadh4v59NhYEeCuQo
iRBEmWFdlwKBgHy8yGIQ89b4P4xpoYHKLRiuk6z6/hBG6sFo4rYxclSBnK+1bny5
OmhefQ461IBGSJLIf7GX4LyQa1M3LM8MwsFUD38CfSrmZeb4vXdSxYR0b75MY3/d
GJ9VSS+5bJqQYWUlM1C6cSfd/oQdiveo/BWZsGRSZMSWyVA2cSKYYArDAoGBAMi7
sqpM4Mpv/Ctgjp/k6tcoy2VTTMI264hxUV2UvzPLgTzYgbVu3+U85SLQpTDGAB5m
Fq1e/lcURq0kWvx6Zlo+r+ted3N3pXmkQU7buBwf3T0zbY0honqSmwd4/z78bPgg
H9+mgaMfd09RoGJ9N2jZFhrTiayqcxVpmUTe2G+pAoGAflzKxOcInb4uI/uaKx16
2LMUzmBnYnwbzuJXYkRqZTq1oxkvIIh7kJ5mjzjIeBZIjLIRRWoNx6srKCopB6gG
S4t4dcp4pzTEP4X6ZnnSiNuh9iqRcdwz5yf3nOUcjs/DMOdsuL7DMnlvwZgPYNON
8PODMw/h3ByeKvk7HsXNYF0=
-----END PRIVATE KEY-----`;

